import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import React from 'react';

import {
    CollectionDeDossierCollectiondossierUpdate,
    CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { useToaster } from '@europrocurement/l2d-modules/hooks';
import { useForm } from 'react-hook-form';
import { Backdrop, CircularProgress } from '@mui/material';

export type ProvisionAttendueType = {
    provision: number;
    typeFacturation: CollectionDeDossierJsonldCollectiondossierReadTypeFacturationEnum;
    collectionId: number;
    afterSubmit: () => void;
};

const ProvisionAttendue: React.FunctionComponent<ProvisionAttendueType> = function (props) {
    const { afterSubmit, collectionId, provision, typeFacturation } = props;

    const [isLoading, setIsLoading] = React.useState(false);

    const { collectionApi } = useFormaliteService();

    type ProvisionAttendueFormObject = {
        montant: string;
    };

    const defaultProvisionAttendue: Partial<ProvisionAttendueFormObject> = {
        montant: (Math.floor(provision * 100) / 100).toFixed(2),
    };

    const formStructure: FormStructure[] = [
        {
            type: 'header',
            label: 'Modifier la provision attendue',
            name: 'main_informations',
        },
        {
            type: 'number',
            inputProps: {
                step: 1,
                min: 0,
            },
            name: 'montant',
            inputlabel: 'Montant',
            placeholder: 'Montant',
            rules: {
                required: 'Vous devez renseigner un montant',
            },
            xs: 12,
            sm: 6,
            md: 3,
            lg: 3,
        },
    ];

    const formContext = useForm({
        mode: 'onTouched',
        defaultValues: defaultProvisionAttendue,
    });

    const { handleApiResponse } = useToaster();

    const onSubmit = async () => {
        setIsLoading(true);
        const collectionDeDossierCollectiondossierUpdate: CollectionDeDossierCollectiondossierUpdate =
            {
                typeFacturation,
                acompteAttendu: formContext.getValues().montant as unknown as string,
            };

        const createRequest = collectionApi.apiCollectionsDossiersIdPatch({
            id: collectionId as unknown as string,
            collectionDeDossierCollectiondossierUpdate,
        });

        await handleApiResponse(createRequest, afterSubmit);
        setIsLoading(false);
    };

    const formProps = {
        formContext,
        onSubmit,
        formObject: {},
    };

    return (
        <>
            <Backdrop
                sx={(backDropTheme) => ({ color: '#fff', zIndex: backDropTheme.zIndex.drawer + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
        </>
    );
};

export default ProvisionAttendue;
